



































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapActions, mapState } from 'vuex';
import _, { map } from 'lodash';
import { Spinner } from 'vue-image-spinner2';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import moment from 'moment-timezone';
import { BFormInput } from 'bootstrap-vue';
import { IDataCloseBox, IDataSale, ISalesPdv } from '@/store/pdv';
import DateRangePicker from 'vue2-daterange-picker'
import { formatMexicoTime } from '@/utils';
import QRCode from 'qrcode';
import VueMonthlyPicker from 'vue-monthly-picker';

@Component({
  name: 'pdv',
  components: {
    Spinner,
    DateRangePicker,
    VueMonthlyPicker,
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapState('pdv', ['info_sale', 'session_pdv', 'close_flag', 'amount_close_flag', 'totalv_history', 'monthlySummary']),
    characterCount() {
      return this.detail_cancel_sale.length;
    },

    // Indica si se excede el límite
    isOverLimit() {
      return this.characterCount > this.MAX_CHARACTERS;
    }

  },
  methods: {
    ...mapActions('pdv', ['getBoxStatus']),
  },
  filters: {
    date(val) {
      return val ? moment(val).format('YYYY/MM/DD') : 'Fecha';
    }
  }
})
export default class Pdvs extends Vue {
  public barcode: string = '';
  // public last_date: any;
  public pdv_id = 0;
  public last_movement: any = {};
  public movs_sale: any = {};
  public reload_movs = {}         // { venta_id: boolean }
  public refresh_movs = {}        // { venta_id: boolean }
  public last_date = {}
  public modal_move = false;
  public intelisis_moves: any = [];
  public MAX_CHARACTERS = 150;
  public detail_cancel_sale: string = '';
  private currentUser: any;
  public info_sale!: any;
  public showModalShowAmount: boolean = false;
  info_sale_aux: Array<any>
  public showModal: boolean = false;
  public delete_products: boolean = false;
  public showModalStatus: boolean = false;
  public showModalPay: boolean = false;
  public montoInicial: number | null = null;
  private discount: number = 0;
  private two_percent: boolean = false;
  private four_percent: boolean = false;
  private eight_percent: boolean = false;
  private eight_percentv: boolean = false;
  private ten_percent: boolean = false;
  private ten_percentv: boolean = false;
  public productos: any[] = [];
  public show_close_box: boolean = false;

  public actual_view: string = ''; // Estado inicial

  public session_pdv!: any;
  public close_flag!: boolean;
  public amount_close_flag!: boolean;
  subtotal_cards: number = 0;
  subtotal_cash: number = 0;
  fixed_amount: number = 0;
  box_cut_amount: number = 0;
  amountCardCredit: any = 0;
  amountCardDebit: any = 0;
  closeSpinner: boolean = false;
  saleSpinner: boolean = false;
  disabledBtnSale: boolean = false;
  box_cut_detail: any = null;
  onet: number = 0;
  twenty: number = 0;
  fiveh: number = 0;
  ten: number = 0;
  twoh: number = 0;
  five: number = 0;
  oneh: number = 0;
  two: number = 0;
  fifty: number = 0;
  one: number = 0;
  fiftyc: number = 0;
  cashCutDetail: any = {};
  disabledButtonCloseBox: boolean = true;
  public active_discount = 0;
  public box_status: any = null;
  public reasonSpinner: boolean = false;
  public showModalConfirmCode: boolean = false;
  public showModalConfirmCodeProduct: boolean = false;
  public showModalConfirmCode2: boolean = false;
  public showModalConfirmCode3: boolean = false;
  discounts = [
    { value: 5, requiresCode: false }
    // { value: 4, requiresCode: false },
    // { value: 8, requiresCode: true },
    // { value: 10, requiresCode: true },
    // { value: 15, requiresCode: true },
    // { value: 20, requiresCode: true },
    // { value: 25, requiresCode: true },
    // { value: 30, requiresCode: true },
    // { value: 35, requiresCode: true },
    // { value: 40, requiresCode: true },
    // { value: 45, requiresCode: true },
    // { value: 50, requiresCode: true }
  ];
  discountSelected = null;         // valor temporal del descuento
  active_discount_percent = null;   // porcentaje activo
  // active_discount = 0;              // valor decimal (ej. 0.1)
  // showModalConfirmCode = false;
  public showModalConfirmCode4: boolean = false;
  public name_manager: string = '';
  product_to_remove: number;
  public codigoConfirmacion: string = '';
  public codigoConfirmacion2: string = '';
  public codigoConfirmacion3: string = '';
  public listaSesiones: any[] = [];
  public ventasSesionSeleccionada: Record<number, any[]> = {};
  public sesionesExpand: { [key: number]: boolean } = {};
  public percent: number = 0;
  ventaSeleccionada: any;
  public searchbar: boolean = true;
  accionPendiente: string;
  codigosGerente: any;
  //Paginacion
  public paginaActual: number = 1;  // Página actual
  public itemsPorPagina: number = 10;  // Cuántos ítems mostrar por página

  public paginaActualVentas: { [sessionId: number]: number } = {};
  public itemsPorPaginaVentas: number = 5;
  readonly totalv_history: number
  loader_tsales: boolean = false
  loader_last_sale: boolean = false
  loader_last_cbox: boolean = false

  public camposSesiones = [
    { key: 'id', label: 'ID Sesión' },
    { key: 'date_open', label: 'Fecha Apertura' },
    { key: 'amount_open', label: 'Monto Inicial' },
    { key: 'acciones', label: 'Acciones' },
  ];

  public camposVentas = [
    { key: 'id', label: 'ID Venta' },
    { key: 'date_created', label: 'Fecha' },
    { key: 'total', label: 'Total' },
    { key: 'subtotal', label: 'Subtotal' },
    { key: 'amount_cash', label: 'Efectivo' },
    { key: 'amount_card_credit', label: 'TC' },
    { key: 'amount_card_debit', label: 'TD' },
    // { key: 'intelisis_movement', label: 'Movimiento en Intelisis' },
    { key: 'estado', label: 'Estado' },
    { key: 'acciones', label: '' },
    { key: 'print', label: '' },
  ];
  public currentModal: any;
  selectedMonth: any = '';
  months: any = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

  readonly date
  formatMexicoTime = formatMexicoTime

  singleDatePicker: any = 'range';

  public dateRange = {
    startDate: null,
    endDate: null,
  };

  @Watch('info_sale', { deep: true })
  onInfoSaleChange() {
    if (this.info_sale.length == 0) {
      this.delete_products = false
      this.eight_percent = false
      this.eight_percentv = false
      this.two_percent = false
      this.four_percent = false
      this.ten_percent = false
      this.ten_percentv = false;
      this.active_discount = 0
    }
    console.log(this.info_sale);
    localStorage.setItem('info_sale', JSON.stringify(this.info_sale));
  }

  getTotalPagadoSin(...excluir: string[]) {
    return Object.entries(this.pagoCombinado)
      .filter(([key, metodo]: any) => metodo.activo && !excluir.includes(key))
      .reduce((sum, [, metodo]: any) => sum + (metodo.monto || 0), 0);
  }

  @Watch('pagoCombinado.td.monto')
  onTDMontoChanged() {
    this.updateRemainingAmount('td');
  }

  @Watch('pagoCombinado.tc.monto')
  onTCMontoChanged() {
    this.updateRemainingAmount('tc');
  }

  @Watch('pagoCombinado.td.activo')
  onTDActivoChanged(val: boolean) {
    if (val) this.activeAutocomplete('td');
  }

  @Watch('pagoCombinado.tc.activo')
  onTCActivoChanged(val: boolean) {
    if (val) this.activeAutocomplete('tc');
  }

  activeAutocomplete(metodoKey: 'td' | 'tc' | 'efectivo') {
    const restante = Number((this.total - this.getTotalPagadoSin(metodoKey)).toFixed(2));
    this.pagoCombinado[metodoKey].monto = restante > 0 ? restante : 0;
  }

  updateRemainingAmount(editedKey: 'td' | 'tc') {
    const otroMetodo = editedKey === 'td' ? 'tc' : 'td';

    // Solo si el otro método está activo
    if (this.pagoCombinado[otroMetodo].activo) {
      const restante = Number((this.total - this.getTotalPagadoSin(otroMetodo)).toFixed(2));
      // Solo actualizar si realmente cambia
      if (this.pagoCombinado[otroMetodo].monto !== restante) {
        this.pagoCombinado[otroMetodo].monto = restante > 0 ? restante : 0;
      }
    }
  }

  @Watch('pagoCombinado', { deep: true })
  onPagoCombinadoChanged(newVal: any) {
    for (const key in newVal) {
      if (!newVal[key].activo) {
        newVal[key].monto = 0;
      }
    }
  }

  async mounted() {
    this.saveUserCode();
    console.log(localStorage.getItem('sale_code'));
    this.getSessions()
    this.show_close_box = this.currentUser.role.name !== 'Cajero' ? true : false;
    this.$nextTick(() => {
      const el = this.$refs.barcodeInput as HTMLInputElement;
      el?.focus();
    });
    this.focusBarcodeInput
    const savedSale = localStorage.getItem('info_sale');
    if (savedSale) {
      try {
        this.$store.commit('pdv/setInfoSale', JSON.parse(savedSale));
      } catch (e) {
        console.error('Error al parsear info_sale:', e);
      }
    }
    try {
      this.box_status = await this.$store.dispatch('pdv/getBoxStatus', this.currentUser.id)
      this.box_status == false ? this.actual_view = 'open box' : this.actual_view = 'sale'
      if (this.currentUser.role.name !== "Cajero" && this.box_status == false)
        this.actual_view = 'open box gerente'
    } catch (error) {
      console.error('Error al cargar datos:', error);
    }
  }

  updated() {
    // Después de cada actualización del componente
    if (this.searchbar && !this.isQuantityInputFocused())
      this.focusBarcodeInput();
  }
  handleGlobalClick(event) {
    const target = event.target as HTMLElement;

    // Solo redirigir si NO es un input
    if (target.tagName !== 'INPUT') {
      setTimeout(() => {
        this.focusBarcodeInput();
      }, 1);
    }
  }

  isQuantityInputFocused(): boolean {
    const activeElement = document.activeElement;
    if (!activeElement || activeElement.tagName !== 'INPUT') {
      return false;
    }

    const inputElement = activeElement as HTMLInputElement;
    return inputElement.type === 'number' &&
      inputElement.classList.contains('text-center');
  }



  // Métodos para cambiar vista
  showViewSale() {
    this.searchbar = true
    this.actual_view = 'sale';
  }

  showViewGerente() {
    this.actual_view = 'open box gerente';
  }

  showViewRecord() {
    this.searchbar = false
    this.actual_view = 'record';
  }

  focusBarcodeInput() {
    this.$nextTick(() => {
      if (this.$refs.barcodeInput) {
        (this.$refs.barcodeInput as any).focus();
      }
    });
  }


  get subtotalBase(): number {
    return this.info_sale.reduce((acc, prod) => {
      const price = Number(prod.price) || 0;
      const quantity = Number(prod.quantity) || 0;
      return acc + (price * quantity);
    }, 0);
  }

  get subtotal(): number {
    return this.subtotalBase - this.discountNow;
  }

  get discountNow(): number {
    return this.subtotalBase * this.active_discount
  }


  get iva(): number {
    return this.subtotal * 0.16;
  }

  get total(): number {
    return this.subtotal + this.iva;
  }

  // get sesionesPaginadas() {
  //   const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
  //   const fin = inicio + this.itemsPorPagina;
  //   return this.listaSesiones.slice(inicio, fin);
  // }


  get totalPagado(): number {
    return Object.values(this.pagoCombinado)
      .filter((m: any) => m.activo)
      .reduce((sum, m: any) => sum + (m.monto || 0), 0);
  }

  get cambio(): number {
    return this.totalPagado > this.total
      ? this.totalPagado - this.total
      : 0;
  }


  public pagoCombinado = {
    efectivo: { activo: false, monto: 0 },
    td: { activo: false, monto: 0 },
    tc: { activo: false, monto: 0 },
  };

  public camposTabla = [
    { key: 'acciones', label: '' },
    { key: 'sku', label: 'SKU' },
    { key: 'description', label: 'Descripción' },
    { key: 'price', label: 'Precio' },
    { key: 'quantity', label: 'Cantidad' },
    { key: 'amount', label: 'Importe' },
  ];
  data() {
    return {
      box_cut_detail: {},
      ventasSesionSeleccionada: {}, // <== para guardar ventas por sesión
      sesionesExpand: {}, // <== para controlar qué acordeón está abierto
      ventaSeleccionada: null,
      accionPendiente: '',
      MAX_CHARACTERS: 150,
      showAmountsForCashier: false,
      movs_sale: {},
    }
  }



  async handleScan(barcode: string) {
    if (!barcode) return;
    console.log('Código escaneado:', barcode);
    const scan = barcode;
    this.barcode = '';
    console.log(scan);



    try {
      const result = await this.$store.dispatch('pdv/getProductInfo', {
        scan,
        vm: this,
        products_sale: this.info_sale
      });
      this.barcode = '';

      if (result && result.length > 0 && result[0] !== null) {
        this.info_sale = result;
        console.log('Array actualizado:', this.info_sale);
      }

      this.focusBarcodeInput();
    } catch (error) {
      console.error('Error al obtener producto:', error);
    }
  }


  limitCharacters() {
    if (this.detail_cancel_sale.length > this.MAX_CHARACTERS) {
      this.detail_cancel_sale = this.detail_cancel_sale.substring(0, this.MAX_CHARACTERS);
    }
  }

  cancelShowAmounts() {
    this.searchbar = true;
    this.showModalShowAmount = false;
  }

  async onSaveCancelDetail() {
    if (
      this.name_manager == '' ||
      this.codigoConfirmacion2 == '' ||
      this.detail_cancel_sale == '' ||
      this.name_manager.trim() == '' ||
      this.codigoConfirmacion2.trim() == '' ||
      this.detail_cancel_sale.trim() == ''
    ) {//Revisar que no sean cadenas vacías
      this.$bvToast.toast('Llena todos los campos para procesar la cancelación', {
        title: 'Campos faltantes',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000,
      });
    } else {
      this.reasonSpinner = true;
      console.log(typeof this.name_manager);
      console.log(typeof this.codigoConfirmacion2);
      console.log(typeof this.detail_cancel_sale);
      const exist = await this.$store.dispatch('pdv/verificarCodigo', this.codigoConfirmacion2)
      if (exist) {
        const venta = this.ventaSeleccionada;
        await this.$store.dispatch('pdv/updateSaleCancelActivate', {
          id: venta.id,
          is_active: this.accionPendiente === 'activar',
        });
        console.log(this.accionPendiente);
        // const detailCancelStatus = this.name_manager + "__" + this.detail_cancel_sale;
        const detailCancelStatus = `PDV-${venta.id} S-${venta.session_id}__${this.name_manager}__${this.detail_cancel_sale}`;
        this.$store.dispatch('pdv/insertCancelDescription', {
          vm: this,
          data: {
            id: venta.id,
            cancel_detail: detailCancelStatus
          }
        });
        await this.getSalesBySession(venta.session_id);

        this.reasonSpinner = false;
      } else {
        this.reasonSpinner = false;
        this.$bvToast.toast('El código ingresado es erróneo', {
          title: 'Error',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000,
        });
      }
    }

    this.name_manager = '';
    this.detail_cancel_sale = '';
    this.codigoConfirmacion2 = '';
    this.showModalStatus = false;
  }



  async confirmCodeRecord() {
    this.reasonSpinner = true;
    this.searchbar = false;
    const exist = await this.$store.dispatch('pdv/verificarCodigo', this.codigoConfirmacion2)
    if (exist) {
      const venta = this.ventaSeleccionada;
      await this.$store.dispatch('pdv/updateSaleCancelActivate', {
        id: venta.id,
        is_active: this.accionPendiente === 'activar',
      });

      if (this.accionPendiente == 'activar') {
        this.$bvToast.toast('Venta activada correctamente ', {
          title: 'Activación',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000,
        });
      }
      await this.getSalesBySession(venta.session_id);
      this.showModalConfirmCode2 = false;
      this.reasonSpinner = false;
      this.accionPendiente = '';
    } else {
      this.$bvToast.toast('El código ingresado es erróneo', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
      this.reasonSpinner = false;
    }
  }

  async abrirCaja() {
    if (this.montoInicial === null || this.montoInicial <= 0) {
      this.$bvToast.toast('Por favor ingresa un monto válido.', {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
      return;
    }
    try {
      this.actual_view = 'sale'
      // console.log('this.currentuser',this.currentUser);


      const payload = {
        amount_open: Number(this.montoInicial),
        user_id: this.currentUser.id,
        date_created: moment().tz('America/Mexico_City').toISOString(),
        date_open: moment().tz('America/Mexico_City').toISOString(),
        date_close: null,
        amount_cash: null,
        amount_box_cut: null,
        amount_card_debit: null,
        amount_card_credit: null,
        amount_detail: null,
      };


      const result = await this.$store.dispatch('pdv/openBox', payload);
      console.log('result', result);
      this.box_status = true;

    } catch (error) {
      if (error.response?.data?.errors) {
        console.error('Errores específicos de Directus:', error.response.data.errors);
      }
    }


    // console.log('Caja abierta con monto:', this.montoInicial);
    // Aquí podrías hacer algo como guardar en backend
    this.montoInicial = null;
    this.showModal = false;
  }

  validarCantidad(producto) {
    // this.searchbar = false
    console.log(producto);
    // Si está vacío (null, undefined, '' o NaN) o menor que 1, lo forzamos a 1
    if (!producto.quantity || isNaN(producto.quantity) || producto.quantity < 1) {
      this.$set(producto, 'quantity', 1); // Para asegurarnos de que Vue lo actualice
    }
  }



  evitarTeclasInvalidas(e, condition) {
    let teclasInvalidas
    if (condition) {
      teclasInvalidas = ['e', 'E', '+', '-', '.', ','];
    } else {
      teclasInvalidas = ['e', 'E', '+', '-'];
    }

    const esCeroInicial = e.key === '0' && (!e.target.value || e.target.selectionStart === 0);

    if (teclasInvalidas.includes(e.key) || esCeroInicial) {
      e.preventDefault();
    }
  }

  evitarPegadoInvalido(e) {
    const data = e.clipboardData.getData('text');
    const numero = parseInt(data, 10);

    // Solo permitimos pegar si es un número entero positivo >= 1
    if (!/^[1-9][0-9]*$/.test(data) || isNaN(numero)) {
      e.preventDefault();
    }
  }

  showModalPayConfirm() {
    this.delete_products = false;
    this.showModalPay = true;
    this.pagoCombinado.efectivo.monto = 0
    this.pagoCombinado.td.monto = 0
    this.pagoCombinado.tc.monto = 0
    this.searchbar = false
  }

  async saveSale() {
    const discount_percentage = this.active_discount * 100;
    const intelisis_agent = this.currentUser.intelisis_agent;
    const totalPagado = Object.values(this.pagoCombinado)
      .filter((m: any) => m.activo)
      .reduce((sum, m: any) => sum + m.monto, 0);
    if (totalPagado < Number(this.total.toFixed(2))) {
      this.$bvToast.toast('El total pagado es insuficiente.', {
        title: 'Advertencia',
        variant: 'warning',
        solid: true
      });
      return;
    }

    try {

      this.saleSpinner = true
      this.disabledBtnSale = true

      const sale = {
        user_id: this.currentUser.id,
        box_id: 1,
        total: +this.total.toFixed(2),
        subtotal: this.subtotal,
        total_discount: this.discountNow,
        is_active: true,
        amount_cash: this.pagoCombinado.efectivo.monto,
        amount_card_debit: this.pagoCombinado.td.monto,
        amount_card_credit: this.pagoCombinado.tc.monto,
        iva_total: +this.iva.toFixed(2),
        change_money: +this.cambio.toFixed(2),
        date_created: moment().tz('America/Mexico_City').toISOString(),
        last_updated: moment().tz('America/Mexico_City').toISOString(),
        discount_applied: discount_percentage,
        invoice_code: this.getRandomCode(5),
        payment_way: this.getPaymentWay().result,
        payment_condition: this.getPaymentWay().condition ? 'CREDITO' : 'CONTADO',
        sale_code: localStorage.getItem('sale_code'),
        discount_percentage,
        intelisis_agent
      };

      // aún sin sale_id porque lo asignamos después en el backend
      const detail_sale = this.info_sale.map((p: any) => ({
        product_id: p.id_product,
        price_sale: parseFloat(Number(p.price).toFixed(2)),
        qty: p.quantity,
        is_active: true
      }));

      // return false;

      this.info_sale_aux = _.cloneDeep(this.info_sale)

      const result = await this.$store.dispatch('pdv/saveSale', {
        sale,
        detail_sale,
        vm: this
      });


      // console.log(result.detail_sale.new_sale);
      if (!result.repeat_sale) {
        console.log(result.detail_sale.new_sale[0].total_discount);
        console.log(result.detail_sale.new_sale[0].subtotal);

        const subtotal_ticket = Number(result.detail_sale.new_sale[0].total_discount) + Number(result.detail_sale.new_sale[0].subtotal)
        console.log(subtotal_ticket);

        const data_sale: IDataSale = {
          total: result.detail_sale.new_sale[0].total ?? 0,
          discount: result.detail_sale.new_sale[0].total_discount ?? 0,
          iva: result.detail_sale.new_sale[0].iva_total ?? 0,
          subtotal: subtotal_ticket ?? 0,
          box: result.detail_sale.new_sale[0].session_id,
          payment_way: result.detail_sale.new_sale[0].payment_way,
          payment_condition: result.detail_sale.new_sale[0].payment_condition,
          date: sale.date_created,
          user: this.currentUser.first_name ?? 'Anónimo',
          code: result.detail_sale.new_sale[0].invoice_code
        }

        this.printTicketSale(result.detail_sale.new_sale[0].id, data_sale)
        console.log("Venta duplicada 2");
      } else {
        console.log("Venta duplicada");
      }

      this.two_percent = false
      this.four_percent = false
      // this.eight_percent = false

      // this.saleSpinner = false
      this.disabledBtnSale = false

      this.showModalPay = false;


      // console.log('Resultado venta:', result);

      this.$store.commit('pdv/setInfoSale', []);
      this.pagoCombinado = {
        efectivo: { activo: false, monto: 0 },
        td: { activo: false, monto: 0 },
        tc: { activo: false, monto: 0 },
      };
    } catch (error) {
      console.error('Error al guardar la venta:', error);
      if (error.response?.data?.errors) {
        console.error('Errores específicos de Directus:', error.response.data.errors);
      }
    } finally {
      this.saleSpinner = false
      this.disabledBtnSale = false
    }
  }

  getRandomCode(length: number) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const array = new Uint8Array(length)
    crypto.getRandomValues(array);
    return Array.from(array, byte => chars[byte % chars.length]).join('');
  }

  aumentarCantidad(index: number) {
    const producto = this.info_sale[index];
    producto.quantity += 1;
    producto.amount = producto.quantity * producto.price;
  }

  disminuirCantidad(index: number) {
    const producto = this.info_sale[index];
    if (producto.quantity > 1) {
      producto.quantity -= 1;
      producto.amount = producto.quantity * producto.price;
    } else {
      if (this.delete_products) {
        this.info_sale.splice(index, 1);
      } else {
        this.eliminarProducto(index, false); // si quieres eliminar si llega a 0
      }
    }
  }

  eliminarProducto(index: number, all_products: boolean) {
    this.searchbar = false;
    this.showModalConfirmCodeProduct = true;
    this.codigoConfirmacion = '';
    if (all_products)
      this.delete_products = true
    this.product_to_remove = index;
  }



  cancelCode() {
    this.searchbar = true;
    this.focusBarcodeInput();
    this.showModalConfirmCodeProduct = false;
    this.delete_products = false
  }

  cancelCodeRecord() {
    console.log("Historial");
    this.searchbar = true;
    this.focusBarcodeInput();
    this.showModalConfirmCode2 = false;
  }

  cancelEightPercent() {
    this.searchbar = true;
    this.showModalConfirmCode3 = false;
    this.eight_percent = false
  }

  cancelTenPercent() {
    this.searchbar = true;
    this.showModalConfirmCode4 = false;
    this.ten_percent = false
    this.eight_percentv = false
  }

  deleteSeveralProduct(element) {
    this.info_sale.splice(element, 1);
  }

  async productToRemove() {
    this.searchbar = true;
    this.focusBarcodeInput();
    console.log('Código ingresado:', this.codigoConfirmacion);
    const exist = await this.$store.dispatch('pdv/verificarCodigo', this.codigoConfirmacion)
    if (exist) {
      if (!this.delete_products) {
        this.info_sale.splice(this.product_to_remove, 1);
      }
      // console.log(this.info_sale);
      this.showModalConfirmCodeProduct = false;
      if (this.delete_products) {
        this.$bvToast.toast('Código verificado, ahora puedes eliminar varios productos a la vez', {
          title: 'Correcto',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000,
        })
      } else {
        this.$bvToast.toast('Código verificado', {
          title: 'Correcto',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000,
        })
      }

    } else {
      this.delete_products = false;
      this.$bvToast.toast('El código ingresado es erróneo', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
    }
  }

  async excelReport() {
    try {
      await this.$store.dispatch('pdv/getDocInvoices')
    } catch (error) {
      console.log(error);
    }
  }

  async getSessionSales(session_id: any) {
    try {
      await this.$store.dispatch('pdv/getSessionSales', { id: session_id })
    } catch (error) {
      console.log(error);
    }
  }


  DiscountTwo() {
    if (this.two_percent == false) {
      this.discount = 0
      this.two_percent = true
      this.four_percent = false
      this.eight_percent = false
      this.eight_percentv = false;
      this.ten_percent = false
      this.ten_percentv = false;
      this.active_discount = 0.02
    } else {
      this.two_percent = false
      this.active_discount = 0
    }
  }

  DiscountFour() {
    if (this.four_percent == false) {
      this.discount = 0
      this.four_percent = true
      this.eight_percent = false
      this.two_percent = false
      this.eight_percentv = false;
      this.ten_percent = false
      this.ten_percentv = false;
      this.active_discount = 0.04
    } else {
      this.four_percent = false
      this.active_discount = 0
    }
  }

  async validateEigthPercent() {
    this.searchbar = true;

    console.log('this.currentUser.confirm_code_pdv', this.currentUser.confirm_code_pdv);
    const exist = await this.$store.dispatch('pdv/verificarCodigo', this.codigoConfirmacion3)
    if (exist) {
      this.showModalConfirmCode3 = false;
      this.eight_percentv = true;
      this.active_discount = 0.08
    } else {
      this.$bvToast.toast('El código ingresado es erróneo', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
    }
    this.focusBarcodeInput();
  }
  DiscountEigth() {
    this.searchbar = false;
    this.active_discount = 0;
    if (this.eight_percent == false) {
      this.eight_percent = true
      this.eight_percentv = false
      this.showModalConfirmCode3 = true;
    } else {
      this.eight_percent = false
      this.active_discount = 0
    }
    this.eight_percentv = false
    this.two_percent = false
    this.four_percent = false
    this.ten_percent = false
    this.ten_percentv = false;
    this.codigoConfirmacion3 = '';
  }

  handleDiscountClick(discount) {
    // si ya estaba activo → lo desactiva
    if (this.active_discount_percent === discount.value) {
      this.active_discount_percent = null;
      this.active_discount = 0;
      return;
    }

    // si el descuento NO requiere código (2% o 4%)
    if (!discount.requiresCode) {
      this.active_discount_percent = discount.value;
      this.active_discount = discount.value / 100;
      return;
    }

    // si sí requiere código (8% o mayores)
    this.discountSelected = discount;
    this.showModalConfirmCode = true;
  }

  async validateDiscount() {
    const exist = await this.$store.dispatch(
      'pdv/verificarCodigo',
      this.codigoConfirmacion3
    );

    if (exist) {
      this.showModalConfirmCode = false;

      this.active_discount_percent = this.discountSelected.value;
      this.active_discount = this.discountSelected.value / 100;

    } else {
      this.$bvToast.toast('El código ingresado es erróneo', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
    }

    this.codigoConfirmacion3 = '';
  }


  cancelDiscount() {
    this.showModalConfirmCode = false;
    this.discountSelected = null;
    this.codigoConfirmacion3 = '';
  }



  async validateTenPercent() {
    this.searchbar = true;

    console.log('this.currentUser.confirm_code_pdv', this.currentUser.confirm_code_pdv);
    const exist = await this.$store.dispatch('pdv/verificarCodigo', this.codigoConfirmacion3)
    if (exist) {
      this.showModalConfirmCode4 = false;
      this.ten_percentv = true;
      this.active_discount = 0.1
    } else {
      this.$bvToast.toast('El código ingresado es erróneo', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
    }
    this.focusBarcodeInput();
  }

  DiscountTen() {
    this.searchbar = false;
    this.active_discount = 0;
    if (this.ten_percent == false) {
      this.ten_percent = true
      this.ten_percentv = false
      this.showModalConfirmCode4 = true;
    } else {
      this.ten_percent = false
      this.active_discount = 0
    }
    this.eight_percentv = false
    this.eight_percent = false
    this.two_percent = false
    this.four_percent = false
    this.codigoConfirmacion3 = '';
  }

  onOpenShowAmountModal() {
    this.showModalShowAmount = true;
    this.codigoConfirmacion = '';
  }

  cancelDetail() {
    this.codigoConfirmacion2 = '';
    this.name_manager = '';
    this.detail_cancel_sale = '';
  }


  async confirmShowAmount() {

    console.log('Código ingresado:', this.codigoConfirmacion);
    const exist = await this.$store.dispatch('pdv/verificarCodigo', this.codigoConfirmacion)
    if (exist) {
      this.show_close_box = true;
      this.showModalShowAmount = false;
      this.$bvToast.toast('Código correcto', {
        title: 'Éxito',
        variant: 'success',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
    } else {
      this.$bvToast.toast('El código ingresado es erróneo', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
    }
  }

  onOpenCloseBoxModal() {
    this.searchbar = false;
    this.$store.dispatch('pdv/getCloseInfo', {
      vm: this,
      data: this.session_pdv,
    });
    this.$bvModal.show('close-box');
  }

  onInputChange(field: any, value: any) {
    const quantity = Number(value) || 0;
    const fieldToDenomination = {
      onet: '1000',
      twenty: '20',
      fiveh: '500',
      ten: '10',
      twoh: '200',
      five: '5',
      oneh: '100',
      two: '2',
      fifty: '50',
      one: '1',
      fiftyc: '0.5'
    };
    // Inicializar cashCutDetail si no existe
    if (!this.cashCutDetail) {
      this.cashCutDetail = {};
    }
    switch (field) {
      case 'onet':
        this.onet = value * 1000;
        break;
      case 'twenty':
        this.twenty = value * 20;
        break;
      case 'fiveh':
        this.fiveh = value * 500;
        break;
      case 'ten':
        this.ten = value * 10;
        break;
      case 'twoh':
        this.twoh = value * 200;
        break;
      case 'five':
        this.five = value * 5;
        break;
      case 'oneh':
        this.oneh = value * 100;
        break;
      case 'two':
        this.two = value * 2;
        break;
      case 'fifty':
        this.fifty = value * 50;
        break;
      case 'one':
        this.one = value * 1;
        break;
      case 'fiftyc':
        this.fiftyc = value * 0.5;
        break;
      case 'credit':
        this.amountCardCredit = +value;
        this.subtotal_cards = Number((+this.amountCardCredit + +this.amountCardDebit).toFixed(2));
        break;
      case 'debit':
        this.amountCardDebit = +value;
        this.subtotal_cards = Number((+this.amountCardCredit + +this.amountCardDebit).toFixed(2));
        break;
      case 'fixed_amount':
        this.fixed_amount = +this.fixed_amount || 0;
        break;
      default:
        console.log('check input field:', field);
        break;
    }

    // Si el campo es uno de efectivo, actualiza el desglose
    if (fieldToDenomination[field]) {
      const denom = fieldToDenomination[field];
      this.cashCutDetail[denom] = quantity;
    }

    // console.log({ session: this.session_pdv });

    this.subtotal_cash = Number(this.onet + this.twenty + this.fiveh + this.ten + this.twoh + this.five + this.oneh + this.two + this.fifty + this.one + this.fiftyc);
    this.box_cut_amount = Number(this.onet + this.twenty + this.fiveh + this.ten + this.twoh + this.five + this.oneh + this.two + this.fifty + this.one + this.fiftyc + +this.amountCardCredit + +this.amountCardDebit);
    // this.box_cut_amount == this.session_pdv.close_box_amount ? this.disabledButtonCloseBox = false : this.disabledButtonCloseBox = true;
    // console.log(this.fixed_amount);
    // console.log(+this.session_pdv.amount_open);

    const isCloseEnough = (a, b, tolerance = 0.5) => Math.abs(a - b) <= tolerance;
    if (
      isCloseEnough(this.box_cut_amount, this.session_pdv.close_box_amount) &&
      isCloseEnough(this.session_pdv.close_box_card, this.amountCardCredit + this.amountCardDebit) &&
      isCloseEnough(this.session_pdv.close_box_cash, this.subtotal_cash) &&
      isCloseEnough(this.fixed_amount, +this.session_pdv.amount_open)
    ) {
      this.disabledButtonCloseBox = false;
    } else {
      this.disabledButtonCloseBox = true;
    }
  }



  async onCloseBox() {
    try {
      this.closeSpinner = true;
      const res_data = await this.$store.dispatch('pdv/closeBox', {
        vm: this,
        data: this.session_pdv,
        totalCash: (this.box_cut_amount - this.amountCardCredit - this.amountCardDebit).toFixed(2),
        totalCredit: this.amountCardCredit,
        totalDebit: this.amountCardDebit,
        total: this.box_cut_amount,
        amountDetail: this.cashCutDetail,
      });

      const data_closebox = res_data.data.data

      const data_close_box: IDataCloseBox = {
        cashdetails: this.cashCutDetail,
        final_cash: this.box_cut_amount,
        initial_cash: data_closebox.amount_open,
        amount_credit: this.amountCardCredit,
        amount_debit: this.amountCardDebit,
        total: this.box_cut_amount,
        user: this.currentUser.first_name ?? 'Anónimo',
        date_close: data_closebox.date_close,
        date_open: data_closebox.date_open,
        amount_cash: (this.box_cut_amount - this.amountCardCredit - this.amountCardDebit),
        fixed_amount: this.fixed_amount,
      }

      this.printCloseBox(this.session_pdv.id, data_close_box)

      if (this.close_flag || this.close_flag == null) {
        this.$bvModal.hide('close-box');
        this.closeSpinner = false;
        const box_status = await this.$store.dispatch('pdv/getBoxStatus', this.currentUser.id);
        box_status == false ? this.actual_view = 'open box' : this.actual_view = 'sale'
      }
    } catch (error) {
      console.log('Error al cerrar caja: ', error);
    }
    finally {
      this.show_close_box = false;
      this.box_cut_detail = {};//Se vacíen los inputs del cierre de caja 
      this.amountCardCredit = 0;
      this.amountCardDebit = 0;
      this.fixed_amount = 0;
      this.subtotal_cash = 0;
      this.subtotal_cards = 0;
      this.box_cut_amount = 0;
    }
  }



  async printTicketSale(id_sale: number, data_sale: IDataSale) {
    // console.log({ id_sale });

    try {
      this.saleSpinner = false;

      // console.log('anterior: ', data_sale.date);

      const clonedSale = _.cloneDeep(data_sale);
      clonedSale.date = this.formatMexicoTime(clonedSale.date);

      // console.log('clonedSale.date:', clonedSale.date);
      // console.log(clonedSale.date.format('DD/MM/YYYY'))
      // console.log(clonedSale.date.format('HH:mm:ss'));

      let html = null, css = null;
      //******** Ticket ***************
      const tiket = await this.htmlTicket(id_sale, clonedSale);
      const css_ticket = await this.getStylesTicket();
      html = tiket;
      css = css_ticket;
      // this.imprimirTicketConIframe(html, css);

      const wind = window.open('', '_blank');
      wind.document.write(`
        <html>
          <head><title>Impresión</title>
          <style>${css}</style>
          </head>
          <body>${html}</body>
        </html>
      `);
      wind.document.close();

      wind.onload = () => {
        wind.focus();
        wind.print();
        wind.close();
      };

      this.info_sale_aux = []; // reset
      this.active_discount = 0;
      this.pagoCombinado.efectivo.monto = 0;
      this.pagoCombinado.td.monto = 0;
      this.pagoCombinado.tc.monto = 0;
      this.focusBarcodeInput();
      this.saveUserCode();
    } catch (error) {
      console.log('Error al imprimir ticket: ', error);
      this.$bvToast.toast('Error al imprimir ticket.', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
      this.saveUserCode()
      return
    }
  }

  imprimirTicketConIframe(html, css) {
    // Asegura que la imagen tenga una ruta absoluta
    const baseUrl = window.location.origin;
    const htmlConRutaImagen = html.replace('/img/logo3navideno.7a6bf6f3.svg', `${baseUrl}/img/logo3navideno.7a6bf6f3.svg`);

    // Crea el iframe
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow?.document;
    if (!iframeDoc) {
      console.error('No se pudo acceder al documento del iframe');
      return;
    }

    // Escribe el contenido HTML dentro del iframe
    iframeDoc.open();
    iframeDoc.write(`
    <html>
      <head>
        <title>Impresión</title>
        <meta charset="utf-8">
        <link href="https://fonts.googleapis.com/css?family=Montserrat:300,500,700,800&display=swap" rel="stylesheet">
        <style>
          ${css}
        </style>
      </head>
      <body>
        ${htmlConRutaImagen}
      </body>
    </html>
  `);
    iframeDoc.close();

    // Espera a que se renderice y luego imprime
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();

        // Limpia el iframe después de imprimir
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 500); // Le damos un poco de tiempo para que cargue bien todo
    };
  }


  async generarYGuardarCodigo() {
    const codigo = this.generarCodigoConfirmacion();

    try {
      const usuario = await this.$store.dispatch('pdv/updateUser', {
        id: this.currentUser.id,
        confirm_code_pdv: codigo,
      });

      // Opcionalmente actualizar en el front también
      this.currentUser.confirm_code_pdv = codigo;

      // await this.getCodesGerente();
      console.log('Código generado y guardado:', codigo);
    } catch (error) {
      console.error('Error al guardar código de confirmación:', error);
    }
  }

  saveUserCode() {
    const code = this.generarCodigoConfirmacion();
    const usercode = this.currentUser.id + '-' + code;
    localStorage.setItem('sale_code', usercode);
  }

  generarCodigoConfirmacion(longitud: number = 5): string {
    const caracteres = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let codigo = '';
    for (let i = 0; i < longitud; i++) {
      codigo += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
    }
    return codigo;
  }

  async getSessions(page: number = 1, start_date = null, end_date = null) {
    try {
      this.loader_tsales = true
      const result = await this.$store.dispatch('pdv/getSessions', { page, start_date, end_date });

      this.listaSesiones = result;
    } catch (error) {
      console.log('Error en historial', error);
    } finally {
      this.loader_tsales = false
    }
  }

  async getSalesBySession(sessionId: number) {
    try {
      const ventas = await this.$store.dispatch('pdv/getSalesBySession', { id: sessionId });
      const ordenadas = ventas.sort((a, b) => {
        if (a.is_active !== b.is_active) return a.is_active ? -1 : 1;
        return new Date(b.date_created).getTime() - new Date(a.date_created).getTime();
      });

      this.$set(this.ventasSesionSeleccionada, sessionId, ordenadas);
    } catch (error) {
      console.error('Error al obtener ventas:', error);
    }
  }

  async toggleVentas(index: number, sessionId: number) {
    const expandiendo = !this.sesionesExpand[index];
    this.$set(this.sesionesExpand, index, expandiendo);

    if (!expandiendo) return; // Si está cerrando, no hace nada

    // Si está abriendo, recarga ventas
    try {
      const ventas = await this.$store.dispatch('pdv/getSalesBySession', { id: sessionId });
      this.$set(this.ventasSesionSeleccionada, sessionId, ventas);
    } catch (error) {
      console.error('Error al obtener ventas por sesión:', error);
    }
  }

  activarVenta(venta: any) {
    this.ventaSeleccionada = venta;
    this.accionPendiente = 'activar';
    this.showModalConfirmCode2 = true;
  }

  async openModalMove(sale_id) {
    this.modal_move = true;
    const intelisis_movement = await this.$store.dispatch('pdv/getIntelisisInfo', { id: sale_id });

    this.intelisis_moves = intelisis_movement.intelisis_movs;
    // console.log(movements);

  }

  openModal(modalId: any) {
    this.currentModal = modalId;
    console.log({ modalId });
    this.$bvModal.show(modalId);
  }

  @Watch('selectedMonth')
  async getSummary() {
    if (this.selectedMonth) {
      let date = moment(this.selectedMonth).format('YYYY/MM');
      if (this.currentModal === "ordersSummary") {
        try {
          await this.$store.dispatch('pdv/getMonthlySales', { date: date, vm: this })
        } catch (error) {
          console.log(error);
        }
      }
      if (this.currentModal === "boxSummary") {
        try {
          await this.$store.dispatch('pdv/getMonthlyBox', { date: date, vm: this })
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  async refreshInfo(session, sale_pdv) {
    // Inicializa si no existen
    if (!this.reload_movs) this.reload_movs = {};
    if (!this.refresh_movs) this.refresh_movs = {};
    if (!this.last_date) this.last_date = {};
    if (!this.last_movement) this.last_movement = {};

    this.$set(this.reload_movs, sale_pdv, true);

    let result;
    try {
      result = await this.$store.dispatch('pdv/RefreshMovIntelisis', {
        sale: sale_pdv,
        session_id: session,
        vm: this
      });

      // Guardamos datos por ID
      this.$set(this.refresh_movs, sale_pdv, true);
      this.$set(this.last_date, sale_pdv, result[result.length - 1].ultimocambio);
      this.$set(this.last_movement, sale_pdv, {
        mov: result[result.length - 1].mov,
        movid: result[result.length - 1].movid
      });
    } catch (error) {
      this.$set(this.reload_movs, sale_pdv, false);
    } finally {
      this.$set(this.reload_movs, sale_pdv, false);
      await this.$store.dispatch('pdv/PatchMovIntelisis', {
        sale_id: sale_pdv,
        intelisis_movs: result
      });
    }
  }



  cambiarPaginaVentas(sesionId: number, nuevaPagina: number) {
    if (nuevaPagina < 1) return;
    const ventas = this.ventasSesionSeleccionada[sesionId] || [];
    const maxPagina = Math.ceil(ventas.length / this.itemsPorPaginaVentas);
    if (nuevaPagina > maxPagina) return;
    this.$set(this.paginaActualVentas, sesionId, nuevaPagina);
  }

  async cambiarPagina(nuevaPagina: number) {

    if (nuevaPagina < 1) return;
    // const maxPagina = Math.ceil(this.listaSesiones.length / this.itemsPorPagina);
    // console.log(maxPagina);
    // if (nuevaPagina > maxPagina) return;
    this.paginaActual = nuevaPagina;

    const start_date = this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY/MM/DD') : null
    const end_date = this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY/MM/DD') : null

    await this.getSessions(nuevaPagina, start_date, end_date)
  }

  ventasPaginadasPorSesion(sesionId: number) {
    const ventas = this.ventasSesionSeleccionada[sesionId] || [];
    const pagina = this.paginaActualVentas[sesionId] || 1;
    const inicio = (pagina - 1) * this.itemsPorPaginaVentas;
    const fin = inicio + this.itemsPorPaginaVentas;
    return ventas.slice(inicio, fin);
  }

  async desactivarVenta(venta: any) {
    // this.ventaSeleccionada = venta;
    // this.showModalStatus = true;
    // // this.searchbar = false;
    // this.accionPendiente = 'desactivar';
    // this.codigoConfirmacion2 = '';
    // console.log("desActivo");
    // console.log('Cancelando venta', venta);
    // ----------------------------
    const result = await this.$store.dispatch('pdv/checkSaleCancel', { sale: venta, vm: this })

    if (result) {
      this.ventaSeleccionada = venta;
      this.showModalStatus = true;
      // this.searchbar = false;
      this.accionPendiente = 'desactivar';
      this.codigoConfirmacion2 = '';
      console.log("desActivo");
    }
  }

  printCloseBox(id_cut: number, data: IDataCloseBox) {

    data.date_open = formatMexicoTime(data.date_open)
    data.date_close = formatMexicoTime(data.date_close);

    let html = null, css = null

    //******** Ticket de cierre de caja ***************
    const tiket = this.htmlTicketCloseBox(id_cut, data)
    const css_ticket = this.getStylesTicketCloseBox()
    html = tiket
    css = css_ticket

    const wind = window.open('', '_blank');

    wind.document.write(`
      <html>
        <head><title>Impresión</title></head>
        <style>${css}</style>
        <body>${html}</body>
      </html>
    `)

    wind.document.close();

    wind.onload = () => {
      wind.focus();
      wind.print();
      wind.close();
    };

  }

  // ---------------- Funciones Ticket de compra -----------------------------------------------------------------

  async getLastSale() {
    try {
      this.loader_last_sale = true
      const result = await this.$store.dispatch('pdv/getLastSale', { session: this.currentUser.id, vm: this })

      if (!result) return

      return await this.reprintTicketSale(null, result)


    } catch (error) {
      this.$bvToast.toast('Ocurrió un error al imprimir ticket de venta', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
      console.log(error);

    } finally {
      this.loader_last_sale = false
    }
  }

  async getLastBoxCut() {
    try {
      this.loader_last_cbox = true
      const result = await this.$store.dispatch('pdv/getLastBoxCut', this.currentUser.id)

      if (!result) {
        this.$bvToast.toast('No se encontraron registros para esta sesión', {
          title: 'Sin resultados',
          variant: 'warning',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000,
        });
        return
      }

      const data_close_box: IDataCloseBox = {
        amount_cash: result.amount_cash,
        amount_credit: result.amount_card_credit,
        amount_debit: result.amount_card_debit,
        box: result.id,
        date_close: result.date_close,
        date_open: result.date_open,
        user: this.currentUser.first_name ?? 'Anónimo',
        initial_cash: result.amount_open,
        final_cash: result.amount_close,
        cashdetails: result.amount_detail,
        total: result.amount_box_cut,
        fixed_amount: result.amount_open
      }

      this.printCloseBox(data_close_box.box, data_close_box)

    } catch (error) {
      this.$bvToast.toast('Ocurrió un error al imprimir el ticket de corte de caja', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
    } finally {
      this.loader_last_cbox = false
    }
  }

  async reprintTicketSale(sale_pdv: ISalesPdv, response = null) {
    try {
      this.loader_tsales = true
      let result

      if (!response) {
        const { data } = await this.$store.dispatch('pdv/getProductByIdSale', sale_pdv)
        result = data.data
      } else {
        result = response
      }

      const items = []

      result.products.forEach((p) => {
        const obj = {
          price: p.price,
          quantity: p.qty,
          description: p.name,
          sku: p.sku
        }
        items.push(obj)
      })

      this.info_sale_aux = [...items]

      // console.log('respuesta del back: ', result.date_created);

      const info: IDataSale = {
        box: result.session_id,
        date: moment(result.date_created).toISOString(),
        discount: result.total_discount,
        iva: result.iva_total,
        subtotal: result.subtotal,
        total: result.total,
        user: result.first_name ? result.first_name : 'Anónimo',
        payment_way: result.payment_way,
        payment_condition: result.payment_condition,
        code: result.invoice_code
      }

      this.printTicketSale(result.id, info)

    } catch (error) {
      this.$bvToast.toast('Ocurrió un error al imprimir ticket de venta', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
      });
      console.log(error);

    } finally {
      this.loader_tsales = false
    }
  }

  async htmlTicket(id_sale: number, data_sale: IDataSale) {
    return `
      <div>
            <header>
            ${this.getHeader(id_sale, data_sale)}
            <br>
            </header>

            <main>

              ${this.getTable()}

              <div style="border-style: double none none none; border-color:black;"></div>

              <div style="font-size: 16px; width:100%; display:flex; justify-content:end; ">
                <div class="content-total">
                  <br>
                  <p class="item-total">
                      <span style="font-weight: bold;">Subtotal: </span>
                      $${Number(data_sale.subtotal)?.toFixed(2)}
                  </p>

                  <p class="item-total">
                      <span style="font-weight: bold;">Descuento: </span>
                      $${Number(data_sale.discount)?.toFixed(2)}
                  </p>

                  <p class="item-total">
                      <span style="font-weight: bold;">IVA (16%): </span>
                      $${Number(data_sale.iva).toFixed(2)}
                  </p>
                  <p class="item-total">
                      <span style="font-weight: bold;">Total: </span>
                      $${Number(data_sale.total).toFixed(2)}
                  </p>
                </div>
              </div>

            </main>
            <br><br>
            <footer>
            ${await this.getFooter(id_sale, data_sale)}
            </footer>
      </div>

        `
  }

  async getStylesTicket() {

    return `

            @import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700,800&display=swap');

            html {
                font-family: 'Montserrat';
                font-size: 18px;
            }

            body { font-family: 'Montserrat'; font-size: 18px; color: black; margin:0 auto; }

            *{
                font-size: 18px;
            }


            p {
                margin: 0;
            }

            .table {
                display: flex;
                flex-direction: column;
                width: 100%;
                color: black;
            }

            .theader,
            .tr {
                display: flex;
                flex-wrap: wrap;
            }


            .theader{
                border-style: none none double none;
                border-color: black;
            }

            .tr{
                page-break-inside: avoid;
            }

            .th{
                padding: 0 8px;
            }

            .td{
              word-break: break-all;
              text-transform: uppercase;
            }

            .th,
            .td {
              padding: 10px 0;
              min-width: 40px;
              letter-spacing: 0.003em;
              font-size: 16px;
              color: black;
            }

            .tr{
              gap: 10px;
            }

            .page {
                display: flex;
                flex-direction: column;
                justify-content:space-between;
            }

            .th{
              padding: 10px 15px;
              line-height: 0.4;
            }

            #printpage {
                width: 100%;
                box-sizing: border-box;
                padding: 0;
                margin: 0;
            }

            #content-total{
                width:70%;
                display:flex;
            }

           .item-total{
                display: flex;
                min-width: 250px;
                justify-content: space-between;
            }

            .header *{
                font-size: 14px;
            }

            @media print {
                @page {
                    size: 100mm 297mm;
                    margin: 5mm 0mm 5mm 10mm;
                }
            }
            `
  }

  getHeader(id_sale, data_sale: IDataSale) {
    return `
        <div class="header" style="text-align: center;">
          <picture>
              <img width="100px" src="${require(`@/assets/logo3navideno.svg`)}" style="object-fit: contain; height: 80px;">
          </picture>
          <h4 style="font-size: 14px; margin-top:10px;">Bodega Navideña</h4>
          <div style="display: flex; flex-direction:column; align-items:center; font-size: 14px">
              <span style="font-size: 14px">Gral. Francisco J. Múgica 386C</span>
              <span style="font-size: 14px">CP. 58040</span>
              <span style="font-size: 14px">MORELIA MICHOACÁN</span>
          </div>

          <h5 style="font-weight: bold; margin-top: 1em;">Nota de Venta</h5>

          <div style="display: flex; justify-content: space-between; margin:1em 0;">
              <p><span style="font-weight: bold;">Folio: </span>PDV-${id_sale}</p>
              <p>${data_sale.date.format('DD/MM/YYYY')}</p>
              <p>${data_sale.date.format('HH:mm:ss')}</p>
          </div>

          <div style="display: flex; justify-content: space-between; margin:0.5em 0; flex-wrap:wrap;">
            <p><span style="font-weight: bold;">Caja: </span>${data_sale.box}</p>
            <p><span style="font-weight: bold;">Usuario: </span>${data_sale.user}</p>
          </div>


          <div style="display: flex; justify-content: space-between; margin:0.5em 0;">
            <p><span style="font-weight: bold;">Forma de pago: </span>${data_sale.payment_way}</p>
            <p><span style="font-weight: bold;">Condición: </span>${data_sale.payment_condition}</p>
          </div>

        </div>
        `
  }

  async getFooter(id_sale, date_sale: IDataSale) {
    const domain = process.env.VUE_APP_DOMAIN_ECOMMERCE || 'http://localhost/';

    const params = new URLSearchParams({
      date: date_sale.date.format('DD-MM-YYYY'),
      time: date_sale.date.format('HH:mm:ss'),
      code: date_sale.code,
      total: date_sale.total.toString(),
      box: date_sale.box.toString()
    })

    const urlqr = `${domain}factura/generar/pdv/${id_sale}?${params.toString()}`;
    let url = null

    try {
      url = await QRCode.toDataURL(urlqr, { errorCorrectionLevel: 'H' });
    } catch (err) {
      console.error('Error generando el QR:', err);
    } finally {
      // return `

      // <div style="text-align:center;">
      //   <p style="font-weight:bold;">¡GRACIAS POR SU COMPRA, VUELVA PRONTO!</p>
      //   <p style="margin-top:16px;">Visítanos en: www.prodelec.mx</p>
      // </div>
      // `; //Qr comentado hasta tener la facturación en el ecommerce
      return `

      <div style="text-align:center;">
        <div>
          <p style="text-align:justify;"">Solo podrá generar la factura correspondiente al mes en curso de su compra, 
          en caso de que el código QR no se escanea correctamente aceeda a la siguiente ruta:
          ${domain}factura/generar/pdv/${id_sale}
          </p>
          <br>
          <p style="text-align:center;">Escanea el QR para facturar</p>
          <img src="${url}" alt="QR Code" />
        </div>
        <p style="text-align:center;">Código de factura: ${date_sale.code}</p>
        <p style="font-weight:bold;">¡GRACIAS POR SU COMPRA, VUELVA PRONTO!</p>
        <p style="margin-top:16px;">Visítanos en: www.prodelec.mx</p>
      </div>
      `;
    }
  }
  cancelCloseBox() {
    this.box_cut_detail = {};//Se vacíen los inputs del cierre de caja 
    this.amountCardCredit = 0;
    this.amountCardDebit = 0;
    this.fixed_amount = 0;
    this.subtotal_cash = 0;
    this.subtotal_cards = 0;
    this.box_cut_amount = 0;
    if (this.currentUser.role.name == 'Cajero') {//para que al darle a Cancelar se dejen de mostrar los montos 
      this.show_close_box = false;
    }
  }

  getTable() {

    let table = ''

    const theaders = this.camposTabla.filter(h => h.key !== 'acciones')

    table += `<div class="table">
            <div class="theader">
        `
    const order_list = ['quantity', 'description', 'sku', 'price', 'amount']

    const fheaders = order_list.map((key) => {

      let label = ''
      const h = theaders.find(h => h.key === key)

      label = h.label

      if (h.key === 'sku') {
        label = 'Artículo'
      }

      if (h.key === 'price') {
        label = 'P. Unit'
      }

      return label
    })

    // se agregan las cabeceras
    fheaders.forEach((head, indx) => {

      if (indx < fheaders.length - 1) {
        table += `<div class="th">${head}&nbsp;&nbsp;|&nbsp;&nbsp;</div>`
      } else {
        table += `<div class="th">${head}</div>`
      }

    })

    // se cierra div de las cabeceras
    table += `</div>`

    //se abre div de productos
    table += '<div class="tbody">'

    this.info_sale_aux.forEach((item) => {

      const unitprice = Number(item.price)

      table += `<div class="tr">`
      table += `<div class="td">${item.quantity}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;`
      table += `${item.description}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;`
      table += `${item.sku}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;`
      table += `${Number(unitprice).toFixed(2)}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;`
      table += `${Number(item.quantity * unitprice).toFixed(2)}</div>`
      table += `</div>`
    });

    // se cierra div de productos
    table += `</div>`

    // se cierra div de table
    table += `</div>`

    return table
  }

  getPaymentWay() {

    /**
      Notación de Forma de pago
  
      01 -- Efectivo
      28 -- T. Débito
      04 -- T. Crédito
      03 -- Transferencia Electronica (DAA)
    *
    */

    const amount_cash = Number(this.pagoCombinado.efectivo.monto as any)
    const amount_credit = Number(this.pagoCombinado.tc.monto as any)
    const amount_debit = Number(this.pagoCombinado.td.monto as any)
    let max_cant = Math.max(amount_cash, amount_credit, amount_debit)
    let result = ''
    let iscredit = false

    if (max_cant === amount_cash) {
      result = '01'
    }

    else if (max_cant === amount_debit) {
      result = '28'
    }

    else {
      result = '04'
      iscredit = true
    }

    return {
      result, // Devuelve solo el monto que haya sido mayor
      condition: iscredit
    }
  }

  // ---------------- Funciones Ticket de cierre de caja -----------------------------------------------------------------

  htmlTicketCloseBox(id: number, data: IDataCloseBox) {
    return `
      <div>
        <header>
          <div class="header" style="text-align: center;">

              <picture>
                  <img width="100px" src="${require(`@/assets/logo3navideno.svg`)}" style="object-fit: contain; height: 80px;">
              </picture>

              <h4 style="font-size: 14px; margin-top:10px;">Bodega Navideña</h4>
              <div style="display: flex; flex-direction:column; align-items:center; font-size: 14px">
                <span style="font-size: 14px">Gral. Francisco J. Múgica 386C</span>
                <span style="font-size: 14px">CP. 58040</span>
                <span style="font-size: 14px">MORELIA MICHOACÁN</span>
              </div>

              <h5 style="font-weight: bold; margin-top: 1em;border-style: dashed none;padding: 1em 0; border-width: 2px; border-color:black;">INFORME DE CIERRE DE CAJA</h5>

              <div style="display: flex; justify-content: space-between; margin-top:1em;">
                  <p><span style="font-weight: bold;">Folio: </span>${id}</p>
                  <p>${data.date_close.format('DD/MM/YYYY')}</p>
                  <p>${data.date_close.format('HH:mm:ss')}</p>
              </div>

              <div style="text-align:initial;">
                  <p><span style="font-weight: bold;">Usuario: </span>${data.user}</p>
              </div>

          </div>
        </header>



        <main>

            <div class="body">


              <div style="margin:0.5em 0;">
                <p><span style="font-weight: bold; margin:5px 0;;">Corte Inicial: </span>$ ${Number(data.initial_cash).toFixed(2) ?? 0} MXN</p>

                <div style="display: flex; justify-content: space-between;">
                    <p>Fecha: ${data.date_open.format('DD/MM/YYYY')}</p>
                    <p>Hora: ${data.date_open.format('HH:mm:ss')}</p>
                </div>
              </div>


              <div style="margin:0.5em 0;">
                <p><span style="font-weight: bold; margin: 5px 0;">Corte Final: </span>$ ${Number(data.final_cash).toFixed(2) ?? 0} MXN</p>

                <div style="display: flex; justify-content: space-between;">
                    <p>Fecha: ${data.date_close.format('DD/MM/YYYY')}</p>
                    <p>Hora: ${data.date_close.format('HH:mm:ss')}</p>
                </div>
              </div>

              <div style="margin:0.5em 0;">
                <p><span style="font-weight: bold;">Monto Crédito: </span>$ ${Number(data.amount_credit).toFixed(2) ?? 0} MXN</p>
                <p><span style="font-weight: bold;">Monto Débito: </span>$ ${Number(data.amount_debit).toFixed(2) ?? 0} MXN</p>
              </div>

              <div style="border-style: solid none none none; border-color:black;"></div>

              <div style="margin-top:0.5em;">
                <p><span style="font-weight: bold;">Monto Efectivo: </span>$ ${Number(data.amount_cash).toFixed(2) ?? 0} MXN</p>
              </div>

              <h6 style="font-weight: bold; margin: 0">Detalle de Efectivo</h6>

                <p><span style="font-weight: bold;">$1000: </span> ${data.cashdetails['1000'] ?? 0}</p>
                <p><span style="font-weight: bold;">$20: </span> ${data.cashdetails['20'] ?? 0}</p>
              </div>

                <p><span style="font-weight: bold;">$500: </span> ${data.cashdetails['500'] ?? 0}</p>
                <p><span style="font-weight: bold;">$10: </span> ${data.cashdetails['10'] ?? 0}</p>
              </div>

                <p><span style="font-weight: bold;">$200: </span> ${data.cashdetails['200'] ?? 0}</p>
                <p><span style="font-weight: bold;">$5: </span> ${data.cashdetails['5'] ?? 0}</p>
              </div>

                <p><span style="font-weight: bold;">$100: </span> ${data.cashdetails['100'] ?? 0}</p>
                <p><span style="font-weight: bold;">$2: </span> ${data.cashdetails['2'] ?? 0}</p>
              </div>

                <p><span style="font-weight: bold;">$50: </span> ${data.cashdetails['50'] ?? 0}</p>
                <p><span style="font-weight: bold;">$1: </span> ${data.cashdetails['1'] ?? 0}</p>
              </div>

                <p><span style="font-weight: bold;">$0.50: </span> ${data.cashdetails['0.5'] ?? 0}</p>
              </div>

              <br>

            </div>

            <div style="border-style: solid none none none; border-color:black;"></div>

                <div class="content-total">
                    <p class="item-total">
                        <span style="font-weight: bold;">Fondo fijo: </span>
                        $${Number(data.fixed_amount).toFixed(2) ?? 0} MXN
                    </p>
                </div>
            </div>

        </main>

        <br><br>

      </div>
  `
  }

  getStylesTicketCloseBox() {

    return `

        @import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700,800&display=swap');

        html {
            font-family: 'Montserrat';
            font-size: 18px;
        }

        body { font-family: 'Montserrat'; font-size: 18px; color: black; width: 72.1mm; }

        *{
            font-size: 14px;
        }

        p {
          margin:0;
        }

        .page {
            display: flex;
            flex-direction: column;
            justify-content:space-between;
        }

        #printpage {
            width: 100%;
            box-sizing: border-box;
            padding: 0;
            margin: 0;
        }

        #content-total{
            width:70%;
            display:flex;
        }

        .item-total{
            display: flex;
            min-width: 250px;
            justify-content: space-between;
        }

        .header *{
            font-size: 14px;
        }

        .body{
            font-size: 14px;
        }

        @media print {
            @page {
                size: 100mm 297mm;
                margin: 5mm 0mm 5mm 10mm;
            }
        }
    `
  }

  // --------------- Funciones filtros historial -------------------------------------------------------------

  async onFilterDateRange() {
    let start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
    let end_date: any = moment(this.dateRange.endDate).add(1, 'd');
    end_date = moment(end_date).format('YYYY/MM/DD') + '';

    if (start_date === 'Fecha invalida' || end_date === 'Fecha invalida') return

    await this.getSessions(this.paginaActual, start_date, end_date)

  }

  async clearDateRange() {
    try {
      this.dateRange = { startDate: null, endDate: null };

      // if (this.$refs.picker) {
      // @ts-ignore
      this.$refs.picker.open = false;
      // }

      await this.getSessions()
    } catch (error) {
      console.log('Error in date_range: ', error);
    }
  }

}
